import React from 'react';
import * as styles from './index.module.scss';

const Pagination = ({
    currentPage,
    pageCount,
    setPage,
    surroundingPageCount = 2,
    path,
    pageNumberPrefix,
    zeroBased = false
}) => {
    const startPage = Math.max(zeroBased ? 0 : 1, currentPage - surroundingPageCount);
    const endPage = Math.min(pageCount - 1, currentPage + surroundingPageCount);

    return (
        <nav className={styles.Nav}>
            {
                currentPage > 1 &&
                <>
                    <PaginationItem
                        key={`${path}-first`}
                        index={0}
                        setPage={setPage}
                        textOverwrite="<<"
                        path={path}
                        pageNumberPrefix={pageNumberPrefix}
                        alwaysVisible={true}
                    />
                    <PaginationItem
                        key={`${path}-prev`}
                        index={currentPage - 1}
                        setPage={setPage}
                        textOverwrite="<"
                        path={path}
                        pageNumberPrefix={pageNumberPrefix}
                        alwaysVisible={true}
                    />
                </>
            }
            {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map(i => (
                <PaginationItem
                    key={`${path}-${i}`}
                    index={i}
                    setPage={setPage}
                    isActive={i === currentPage}
                    path={path}
                    pageNumberPrefix={pageNumberPrefix}
                />
            ))}
            {
                currentPage < pageCount &&
                <>
                    <PaginationItem
                        key={`${path}-next`}
                        index={currentPage + 1}
                        setPage={setPage}
                        textOverwrite=">"
                        path={path}
                        pageNumberPrefix={pageNumberPrefix}
                        alwaysVisible={true}
                    />
                    <PaginationItem
                        key={`${path}-last`}
                        index={pageCount - 1}
                        setPage={setPage}
                        textOverwrite=">>"
                        path={path}
                        pageNumberPrefix={pageNumberPrefix}
                        alwaysVisible={true}
                    />
                </>
            }
        </nav>
    );
};

const PaginationItem = ({
    index,
    setPage,
    isActive,
    alwaysVisible, // Just inline style, this way the only way to override in css is with !important
    textOverwrite,
    path,
    pageNumberPrefix
}) => {
    const handleClick = e => {
        e.preventDefault();
        setPage(index);
    };

    if (typeof setPage === 'function')
        return (
            <button
                onClick={handleClick}
                className={`${styles.NavItem} ${isActive ? styles.active : ''}`}
                style={{
                    display: (alwaysVisible) ? 'flex' : ''
                }}
            >{textOverwrite ? textOverwrite : index + 1}</button>
        );
    else
        return (
            <a
                href={(index > 1) ? `${path}/${pageNumberPrefix}${index}` : path}
                className={`${styles.NavItem} ${styles.NavItemAnchor} ${isActive ? styles.active : ''}`}
                style={{
                    display: (alwaysVisible) ? 'flex' : ''
                }}
            >{textOverwrite ? textOverwrite : index}</a>
        );
}

export default Pagination;